export default "__VITE_ASSET__ea139db9__"